import React from 'react'

import Header from '../../components/header/index.js'
import Footer   from '../../components/footer/index.js'
import ManualFileRegister from '../../components/manualFileRegister/index.js'

const RegisterManualFile = () => {

    return (
        <div>
            <Header />

            <ManualFileRegister />

            <Footer />
        </div>
    );
}

export default RegisterManualFile;